<template>
<div class="divider">
    <p class="contentLabel contentLabelPadding">{{ $t('Add.General.Padding') }}</p>
    <div class="range-container">
    <label for="paddingLeft"><span class="material-symbols-outlined padding">align_horizontal_left</span></label>
    <input type="range" min="0" max="100" v-model="padding.left" class="slider" id="paddingLeft" />
    <span>{{padding.left }} px</span>
    </div>
    <div class="range-container">
    <label for="paddingRight"><span class="material-symbols-outlined padding">align_horizontal_right</span></label>
    <input type="range" min="0" max="100" v-model="padding.right" class="slider" id="paddingRight" />
    <span>{{padding.right }} px</span>
    </div>
    <div class="range-container">
    <label for="paddingTop"><span class="material-symbols-outlined padding">align_vertical_top</span></label>
    <input type="range" min="0" max="100" v-model="padding.top" class="slider" id="paddingTop" />
    <span>{{padding.top }} px</span>
    </div>
    <div class="range-container">
    <label for="paddingBottom"><span class="material-symbols-outlined padding">align_vertical_bottom</span></label>
    <input type="range" min="0" max="100" v-model="padding.bottom" class="slider" id="paddingBottom" />
    <span>{{padding.bottom }} px</span>
    </div>
</div>
</template>

<script>
export default {
    props: ['sharedData'],
    computed:{
    padding: {
      get() {
        return this.sharedData?.data?.style?.padding || { top: 0, right: 0, bottom: 0, left: 0 };
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.padding = value;
      },
    },
    }
}
</script>

<style>
@import '../../../styles/addComponents.css';
</style>